<template>
  <div>
    <div class="custom-actions">
      <button
        class="btn btn-danger btn-micro"
        @click="onAction('view-item', rowData, rowIndex)"
      >
        {{ $t("domain.deleteZone") }}
      </button>
    </div>
    <vuestic-modal
      show.sync="true"
      ref="mediumModal"
      :okText="'modal.confirm' | translate"
      v-on:ok="confirm"
      :cancelText="'modal.cancel' | translate"
    >
      <div slot="title">{{ $t("domain.deleteZone") }}</div>
      <div>{{ $t("domain.deleteZoneModalBody") }}</div>
    </vuestic-modal>
  </div>
</template>

<script>
import store from "../../store";
import ajax from "services/ajax";

export default {
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  methods: {
    itemAction(action, data, index) {
      console.log("custom-actions: " + action, data.name, index);
    },
    onAction(action, data, index) {
      // this.$router.push('/management/' + data.hosting_id)
      this.selected = data;
      this.$refs.mediumModal.open();
    },
    confirm() {
      store.commit("setLoading", true);
      ajax.run(
        this,
        "customer/domains/" + this.selected.id,
        (data) => {
          setTimeout(function () {
            store.commit("setLoading", false);
            window.location.reload();
          }, 2000);
          this.showToast(this.$t("domain.deleteSuccess"), {
            icon: "fa-star-o",
            position: "top-center",
            duration: 3000,
            fullWidth: false,
          });
        },
        (error) => {
          store.commit("setLoading", false);
          console.log(error);
        },
        "delete"
      );
    },
  },
};
</script>

<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}
.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/domains/ManageAction.vue